module.exports = __webpack_public_path__ + "media/img/specialize/item9-9346a76034c877a110c026888e6cfc8b.svg";